<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Branch
 * @created at      :   2024/07/16
 * @created by      :   Hainn – HaiNN@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import store from '@/store';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupBranch from '@/views/popupSearch/popup_branch/store';
/**
 * Define component for popup
 */
import helpers from '@/utils/helpers';
var Branch = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupBranch')) {
            store.registerModule('PopupBranch', PopupBranch);
        }
    },
    created() {
        this.onInitScreen();
        if (this.initData) {
            this.customer_cd = this.initData;
        } else {
            this.customer_cd = '';
        }
        this.onSearchItem();
    },
    data() {
        return {
            customer_cd: ''
        };
    },
    mounted() {
        const btnClose = document.querySelector('.btn-close');
        if (btnClose) {
            btnClose.addEventListener('click', this.clearBranchCd);
        }
        window.addEventListener('keydown', this.handleEscKey);
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupBranch', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupBranch', ['searchBranchInfo']),
        ...mapMutations('PopupBranch', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.data.customer_cd = this.customer_cd;
            this.searchBranchInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.customer_cd = this.customer_cd;
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchBranchInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseBranch(data) {
            this.$emit('onReferModelValue', data.location_cd);
            this.$emit('onReferValueName', data.location_name);
            // this.$emit('referDataChoose', data);
            this.$emit('close');
            this.data.location_cd = '';
            this.data.location_name = '';
        },
        clearBranchCd() {
            this.data.location_cd = '';
            this.data.location_name = '';
        },
        handleEscKey(event) {
            if (event.key === 'Escape' || event.keyCode === 27) {
                this.data.location_cd = '';
                this.data.location_name = '';
            }
        }
    }
};
export default Branch;
</script>
<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
